import { scaleLinear, scaleLog } from 'd3-scale';
import { range } from 'lodash';
import { HeatmapScaleTypes } from 'Widgets/HeatMap/constants';
const defaultMinValue = 0.0000001;
const defaultMaxValue = 0.000001;
export const getScaleLabels = (scaleType, min, max, scaleSteps) => {
    switch (scaleType) {
        case HeatmapScaleTypes.LOGARITHMIC: {
            const validMinValue = min > 0 ? min : defaultMinValue;
            const minLog = Math.log(validMinValue);
            const validMaxValue = max > defaultMinValue ? max : defaultMaxValue;
            const maxLog = Math.log(validMaxValue);
            const logStep = (maxLog - minLog) / scaleSteps;
            return range(scaleSteps + 1).map((_, idx) => Math.E ** (minLog + idx * logStep));
        }
        default: {
            const step = (max - min) / scaleSteps;
            return range(scaleSteps + 1).map((_, idx) => min + idx * step);
        }
    }
};
export const getScale = (scaleType, min, max) => {
    switch (scaleType) {
        case HeatmapScaleTypes.LOGARITHMIC: {
            const validMinValue = min > 0 ? min : defaultMinValue;
            const validMaxValue = max > defaultMinValue ? max : defaultMaxValue;
            const scale = scaleLog().domain([validMinValue, validMaxValue]).range([0, 100]);
            return scale;
        }
        default: {
            const scale = scaleLinear().domain([min, max]).range([0, 100]);
            return scale;
        }
    }
};
